export default {
  setCreateData(createData) {
    const rangeType = createData.range_type;
    switch (rangeType) {
      case 'exclusive':
        createData.factories = [];
        break;
      case 'general':
        createData.exclusive_factories = null;
        break;
      default:
        break;
    }
    return createData;
  },
  /**
   * 判斷文章是否創建於當前版本
   * @param {Object} item - 包含 act_version 屬性的項目
   * @param {Object} modelData - 包含 last_version 屬性的模型資料
   * @returns {boolean} - 如果文章創建於當前版本則返回 true，否則返回 false
   */
  isArticleCreatedInCurrentVersion(item, modelData) {
    if (!item || !item.act_version || !modelData || !modelData.last_version) {
      return false;
    }
    const articleCreatedActVersionId = item.act_version.id;
    const currentActVersionId = modelData.last_version.id;
    return articleCreatedActVersionId === currentActVersionId;
  },
  getBatchCreateMultiLangLink(actId, lastVersionId) {
    if (!actId || !lastVersionId) return null;
    return `/act/${actId}/act_version/${lastVersionId}/article/batch-create-multi-lang`;
  },
};
